/**
 * mod by caozh on 2018/5/31.
 */
;(function () {

    uploadPicCtrl.$inject = ['$timeout', '$interval', '$scope', '$q', 'request'];
    angular
        .module('DSSXAPP')
        .component('uploadBankPic', {
            template:'<div class="upload-bank-pic-container"><div class="head">从图片银行选择图片 <span class="close-btn" ng-click="vm.f.close()">×</span></div><div class="pic-select-block"><div class="pic-group-block"><div><span>所有图片</span></div><p>未分组</p></div><div class="pic-list-block"><div class="pic-filter-block"><div><input type="text" class="search-input" placeholder="在所有图片下搜索"> <button class="search-btn" disabled></button></div><div class="drow-down-menu">筛选 <span>所有上传人 <img src="../../../../images/product-post/arr_bottom.png"></span> <span>所有引用状态 <img src="../../../../images/product-post/arr_bottom.png"></span></div><div class="drow-down-menu">排序 <span>更新时间 <img src="../../../../images/product-post/arr_bottom.png"></span></div></div><div class="pic-list"><div class="bank-pic-box" ng-repeat="($index, item) in vm.d.picList"><div class="img" style="background-image: url({{item.img}});"><div class="select"><input type="checkbox" ng-click="vm.f.selectBankPic(item)" ng-checked="vm.f.checkCtrl(item)"> <span></span></div></div><p>{{item.name}}</p></div></div><div class="pagination-block"><bank-pic-pagination dataperpage="vm.c.paginationConfig.numberOfPage" numberofdata="vm.c.paginationConfig.numberOfData" numberofshow="vm.c.paginationConfig.numberOfShow" currentpage="vm.c.paginationConfig.currentPage" onlypagination="vm.c.paginationConfig.onlypagination" change-page="vm.f.search(page)"></bank-pic-pagination></div></div></div><div class="tips-block"><button class="submit-btn" ng-click="vm.f.sendPicToEditor()">确定</button> <span>已选择({{vm.d.selectedPicList.length}}/{{vm.picCount}})</span></div><div class="selected-pic-block"><div class="img" style="background-image: url({{item.url}});" ng-repeat="($index, item) in vm.d.selectedPicList"><div class="delete" ng-click="vm.f.removeSelectedPic($index)">删除</div></div><div class="normal" ng-repeat="item in vm.d.normal"><span>{{item}}</span></div></div></div>',
            bindings: {
                show: '=', // 是否显示该组件
                picCount: '<', // 可以上传的图片张数
            },
            controllerAs: 'vm',
            controller: uploadPicCtrl
        })

    function uploadPicCtrl($timeout, $interval, $scope, $q, request) {

        var vm = this

        vm.c = {
            paginationConfig: {
                numberOfPage: 18, // 列表每页显示多少条数据
                numberOfData: 0, // 总共多少条数据
                numberOfShow: 5, // 每次显示多少个页码
                currentPage: 1, // 当前显示哪一页
                onlypagination: true // 不显示输入跳转
            }
        }

        vm.d = {
            picCount: null,
            picList: [], // 银行图片数据
            selectedPicList: [], //已选的银行图片数据,
            normal: [], // $('.normal)数据
        }

        vm.f = {
            close: close, // 隐藏组件
            search: getBankPicData, // 向后端请求银行图片数据
            selectBankPic: selectBankPic, // 点击图片事件
            checkCtrl: checkCtrl, // 控制图片是否选中
            removeSelectedPic: removeSelectedPic, // 删除已选择的银行图片
            sendPicToEditor: sendPicToEditor, // 将已选的银行图片显示到编辑器当中
        }

        onInit();

        function onInit() {
            initScopeWatch();
            getBankPicData(1);
        }

        // 监听参数
        function initScopeWatch() {
            $scope.$watch("vm.show", function (nv, ov) {
                if (nv) {
                    uploadPicIndex = layer.open({
                        type: 1,
                        title: false,
                        closeBtn: 0,
                        area: ["958px", "672px"],
                        content: $('.upload-bank-pic-container'),
                        cancel: function () {
                            vm.f.close()
                        }
                    });
                }
            })
            $scope.$watch("vm.picCount", function (nv, ov) {
                if (nv) {
                    vm.d.picCount = vm.picCount
                    normalLengthCtrl()
                }
            })
        }

        // 关闭弹出层
        function close() {
            hideUploadComponent();
            vm.d.selectedPicList = []
            normalLengthCtrl()
            layer.close(uploadPicIndex);
        }

        // 改变layer显示状态
        function hideUploadComponent() {
            $timeout(function () {
                vm.show = false;
            })
        }

        // 加载关键词数据
        function getBankPicData(page) {
            var params = {
                page: page,
                pageCount: 18
            };

            return requestBankPicData(params).then(callback, errCallback);

            function callback(res) {
                console.log(res)
                // 初始化分页条数据
                vm.c.paginationConfig.numberOfData = res.data.count
                vm.c.paginationConfig.currentPage = page
                // 保存银行图片数据
                vm.d.picList = res.data.imgs
            }

            function errCallback(error) {
                layer.close(loading);
                DSSX.dialog.err(error, {
                    moduleName: '产品发布-加载银行图片',
                    funcName: 'getBankPicData',
                    text: '加载银行图片失败'
                });
                return $q.reject(error);
            }
        };

        function requestBankPicData(params) {
            return request.get('/usr/api/listImgBank', params, true);
        }

        // 点击选择银行图片事件
        function selectBankPic(obj) {
            var exist = false
            if (vm.d.selectedPicList.length > 0) {
                for (var i = 0; i < vm.d.selectedPicList.length; i++) {
                    if (vm.d.selectedPicList[i].url === obj.img) {
                        exist = true
                        vm.d.selectedPicList.splice(i, 1)
                    }
                }
            }
            if (!exist) {
                vm.d.selectedPicList.push({
                    url: obj.img,
                    name: obj.name
                })
            }
            normalLengthCtrl()
        }

        // 控制银行图片是否选中
        function checkCtrl(obj) {
            for (var i = 0; i < vm.d.selectedPicList.length; i++) {
                if (vm.d.selectedPicList[i].url === obj.img) {
                    return true
                }
            }
        }

        // 控制$('.normal)的数量
        function normalLengthCtrl() {
            var arr = []
            for (var i = vm.d.selectedPicList.length + 1; i <= vm.d.picCount; i++) {
                arr.push(i)
            }
            vm.d.normal = arr
        }

        // 删除已选择的银行图片
        function removeSelectedPic(index) {
            vm.d.selectedPicList.splice(index, 1)
            normalLengthCtrl()
        }

        // 将已选的银行图片显示到编辑器当中
        function sendPicToEditor() {
            if (!vm.d.selectedPicList.length) {
                layer.msg('请选择图片');
            } else if (vm.d.selectedPicList.length <= vm.d.picCount) {
                var picArr = []
                vm.d.selectedPicList.forEach (function (item) {
                    picArr.push(item.url + '?attachment=' + item.name + '&dl=1&filename=' + item.name)
                })
                DSSX.customEditorUploaderPichandler.onSuccess(picArr)
                close()
            }else {
                layer.msg('不能选择超过'+vm.d.picCount+'张图片');
            }
        }

    }
})()